type TCFAPI = {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    __tcfapi: any;
};

export type WindowWithTCFAPI = Window & typeof globalThis & TCFAPI;

export default function footerUI() {
    return function () {
        function init() {
            const cookiePolicyLink = document.getElementById('cookie_policy');
            if (!cookiePolicyLink) {
                return;
            }

            cookiePolicyLink.addEventListener('click', function (event) {
                if ((window as WindowWithTCFAPI).__tcfapi) {
                    event.preventDefault();

                    const LiveRampVersion = 2;
                    (window as WindowWithTCFAPI).__tcfapi(
                        'showConsentManager',
                        LiveRampVersion
                    );
                }
            });
        }

        window.addEventListener('DOMContentLoaded', init);
    };
}
